const messages = {
    selectAUser: 'Select a user',
    selectAManager: 'Select a manager',
    assignManager: 'Assign manager',
    assignProvider: 'Assign provider',
    manager: 'Manager',
    managers: 'Managers',
    userPhone: 'User phone',
    userEmail: 'User email',
    lastMessage: 'Last Message',
    lastMessageTime: 'Last Message Time',
    departmentCategory: 'Department Category',
    phoneNumber: 'Phone number',
    media: 'Media',
    twilioSid: 'Twilio Sid',
    sales: 'Sales',
    marketing: 'Marketing',
    coordination: 'Coordination',
    internal: 'Internal',
    recording: 'Recording',
    messageHistory: 'Message history',
    importHistory: 'Import history',
    selectACategory: 'Select a category',
    addNumber: 'Add number',
    editNumber: 'Edit number',
    messagingDisabledErrorMessage:
        'Messaging with this number is disabled as it is shared with multiple contacts.',
    messagingParticipantNotFoundMessage:
        'This patient has not been assigned to you for messaging. If you believe this is an error, please contact your system administrator.',
};

export default messages;
